import type { TFunction } from "i18next";
import { PriceListItemCalculateType } from "@exonn/js-sdk";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const getCalculateTypeOptions = ({
  t,
  belongsToAutomaticPriceList,
}: {
  t: TFunction;
  belongsToAutomaticPriceList: boolean;
}) => {
  return [
    {
      value: "none" as const,
      disabled: !belongsToAutomaticPriceList,
      label: getResourceFieldTranslation({
        resource: ResourceEnum.PriceListItem,
        type: "option_label",
        field: "status",
        t,
        value: "price_list_calculation",
      }),
    },
    {
      value: PriceListItemCalculateType.Percent as const,
      label: getResourceFieldTranslation({
        resource: ResourceEnum.PriceListItem,
        type: "option_label",
        field: "status",
        t,
        value: "percent",
      }),
    },
    {
      value: PriceListItemCalculateType.Absolute as const,
      label: getResourceFieldTranslation({
        resource: ResourceEnum.PriceListItem,
        type: "option_label",
        field: "status",
        t,
        value: "absolute",
      }),
    },
    {
      value: PriceListItemCalculateType.Fixed as const,
      label: getResourceFieldTranslation({
        resource: ResourceEnum.PriceListItem,
        type: "option_label",
        field: "status",
        t,
        value: "fixed",
      }),
    },
  ];
};
